<template src="./role_form.html"></template>

<script>
import { ViewRole, UpdateRole } from '@/api/auth'

export default {
  name: 'edit-role',
  data: function () {
    return {
      model: {
        role: '',
        note: ''
      },
      ruleValidate: {
        role: [{
          required: true,
          message: '必须填写角色名称',
          trigger: 'blur'
        }]
      }
    }
  },
  props: ['meta'],
  methods: {
    init: function (item) {
      ViewRole(item).then(async res => {
        this.model = res
      })
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      UpdateRole(this.model).then(async res => {
        if (res.role) {
          this.$store.commit('refresh')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
